"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var Grid_1 = require("@material-ui/core/Grid");
var withStyles_1 = require("@material-ui/styles/withStyles");
var Cart_1 = require("./Cart");
var CartSummary_1 = require("./CartSummary");
var styles_1 = require("./styles");
var CartPage = /** @class */ (function (_super) {
    __extends(CartPage, _super);
    function CartPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartPage.prototype.render = function () {
        var _a = this.props, cart = _a.cart, classes = _a.classes, onRemoveClick = _a.onRemoveClick;
        return (React.createElement(Grid_1.default, { direction: "row", container: true, className: classes.cartContainer },
            React.createElement(Grid_1.default, { container: true, className: classes.cartGridColumn, xs: 12, sm: 8, direction: "column" },
                React.createElement(Cart_1.default, { cart: cart, onRemoveClick: onRemoveClick })),
            React.createElement(Grid_1.default, { container: true, className: classes.cartGridColumn, xs: 12, sm: 4, direction: "column" },
                React.createElement(CartSummary_1.default, { cart: cart }),
                React.createElement(Button_1.default, { color: "primary", variant: "contained", className: classes.checkoutButton, onClick: this.props.onCheckoutClick, size: "large" }, "Proceed To Checkout"))));
    };
    return CartPage;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(CartPage);
